export const getDiffFromCurrentSlide = (
  currIndex: number,
  i: number,
  length: number
) => {
  const diff = Math.abs(currIndex - i)
  return diff < length / 2 ? diff : length - diff
}
